import React from 'react'
import ContactSection from './ContactSection'
import ContactFooter from './ContactFooter'
import Header from '../../Components/Header'
import CallToAction from '../../LandingSection/CallToAction'
import Footer from '../../Components/Footer'

const ContactUs = () => {
  return (
    <>
         <Header bgColor="#121212"/>
        <ContactSection/>
        <ContactFooter/>
        <CallToAction/>
        <Footer/>
    </>
  )
}

export default ContactUs